export default __webpack_public_path__ + "static/placeholder-2-de104c2abee3615dea53b453c0d51959.jpg";